import React from 'react';
import { Divider } from 'semantic-ui-react';

import { formatDateUntilToday } from 'utils/dateTimeHelpers';
import { formatNumber } from 'utils/stringFormattingHelpers';

import { BdIcon } from 'components/_common/BdIcon';
import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';
import { SparkTooltipLoading } from 'components/_controls/DiseaseActivityControls/DaSparkTooltipLoading';

type SparkTooltipProximalProps = {
  isLoading?: boolean;
  isInsufficientData?: boolean;
  timeframeStartDate: Date;
  aoiName: string;
  countryName: string;
  casesInAoi: number;
  isCountry: boolean;
  casesInCountry: number;
  aggregationDaysStr: string;
};

export const SparkTooltipProximal: React.FC<SparkTooltipProximalProps> = ({
  isLoading = false,
  isInsufficientData = false,
  timeframeStartDate,
  aoiName,
  countryName,
  casesInAoi,
  isCountry,
  casesInCountry,
  aggregationDaysStr,
}) => {
  return isLoading ? (
    <SparkTooltipLoading />
  ) : isInsufficientData ? (
    <>
      <Typography variant="subtitle2" color="stone10">
        Insufficient case data
      </Typography>
      <Typography variant="caption" color="stone10">
        From {formatDateUntilToday(timeframeStartDate)}
      </Typography>
    </>
  ) : (
    <div>
      <Typography variant="caption" color="stone10">
        From {formatDateUntilToday(timeframeStartDate)}
      </Typography>
      <FlexGroup prefix={<BdIcon name="icon-graph" color="seafoam80" />}>
        <Typography variant="subtitle2" color="white">
          {formatNumber(casesInAoi, 'case', 'cases', 'emdash-0')}
        </Typography>
        <Typography variant="caption" color="stone10">
          reported in {aoiName}
        </Typography>
      </FlexGroup>
      {!isCountry && (
        <FlexGroup prefix={<BdIcon name="icon-graph" color="sea30" />}>
          <Typography variant="subtitle2" color="white">
            {formatNumber(casesInCountry, 'case', 'cases', 'emdash-0')}
          </Typography>
          <Typography variant="caption" color="stone10">
            reported in {countryName}
          </Typography>
        </FlexGroup>
      )}
      <Divider className="spark-tooltip" />
      <Typography variant="caption" color="stone10">
        Each bar = {aggregationDaysStr}
      </Typography>
    </div>
  );
};
